import { useTranslation } from 'react-i18next';

export const keyPrefix = 'departmentPermissionTagList';
export const useDepartmentPermissionTagListTranslation = () => useTranslation('widgets', { keyPrefix });
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Теги доступа',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Permission tags',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Etiquetas de acceso',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Tags de acesso',
  },
}) : {}) as Record<string, unknown>;
